/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EventService, PermissionService, TimeService, UtilService } from '@dm/core';
import { GlobalDataService } from 'app/common/services';
import { type Alarm } from 'app/common/types/mo';
import { AlarmAbstract } from 'app/feature/home/alarm-chart/alarm-abstract';
import { HomeStrService } from 'app/feature/home/home-str.service';

import { GuideStorageKey } from '../smart-assistant.const';
import { SmartAssistantService } from '../smart-assistant.service';
import { SmartAssistantAlarmsStrService } from './assistant-alarms-str.service';

@Component({
    selector: 'app-smart-assistant-alarms',
    templateUrl: './assistant-alarms.component.html',
    styleUrls: ['../../../home-s/alarm-chart-s/alarm-chart-s.component.scss', './assistant-alarms.component.scss'],
})
export class SmartAssistantAlarmsComponent extends AlarmAbstract {
    /**
     * 处于“告警和事件”页面则不限制最大高度
     */
    @Input() showAll = true;
    /**
     * 最大高度
     */
    @Input() maxHeight = '100%';
    /**
     * 国际化
     */
    i18nLabel = this.alarmStr.i18n;
    /**
     * 助手里最多展示5条告警
     */
    SHOW_QUANTITY = 5;
    /**
     * 转义
     */
    decodeHTML = this.utilService.decodeHTML;

    constructor(
        public utilService: UtilService,
        public alarmStr: SmartAssistantAlarmsStrService,
        public el: ElementRef,
        protected str: HomeStrService,
        protected eventService: EventService,
        protected timeService: TimeService,
        protected router: Router,
        protected globalDataService: GlobalDataService,
        protected permissionService: PermissionService,
        private smartAssistantService: SmartAssistantService,
    ) {
        super(str, eventService, timeService, utilService, router, globalDataService, permissionService);
    }

    initData(): void {
        super.initData(this.SHOW_QUANTITY);
    }

    /**
     * 只显示告警详情
     * @param alarm 告警数据
     */
    onlyShowDetail(alarm: Alarm): void {
        // 此时需要将智能助手隐藏
        this.smartAssistantService.setGuideConfig(GuideStorageKey.showSmartAssistant, false);
        super.jumpToAlarmDetailWithState(alarm);
    }

    /**
     * 跳转到告警详情，智能助手展示“导出日志”
     * @param alarm 告警数据
     */
    doCollection(alarm: Alarm): void {
        this.smartAssistantService.setGuideConfig(GuideStorageKey.showExportLog, true);
        super.jumpToAlarmDetailWithState(alarm);
    }
}
